module.exports = __webpack_public_path__ + "img/1.c314b2dd.png";